import { render, staticRenderFns } from "./LugarContactos.vue?vue&type=template&id=3b48b06e"
import script from "./LugarContactos.vue?vue&type=script&lang=js"
export * from "./LugarContactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports